module.exports = __webpack_public_path__ + "static/media/teams-intelligence.462d9118.svg";